import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getViewAllAnnouncementSlice = createApi(`GetViewAllAnnouncementSlice`,"GET");

const GetViewAllAnnouncementSlice = createSlice({
  name: 'GetViewAllAnnouncementSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getViewAllAnnouncementSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getViewAllAnnouncementSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getViewAllAnnouncementSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetViewAllAnnouncementSlice.reducer;